export default "__VITE_ASSET__BO30Op$d__"